import { memoize } from "lodash";
import { observable, runInAction } from "mobx";
import { isDefinedString, reduce } from "et3-type-guards";
import { DEFAULT_TIME } from "../../../constants/input-entries-constants";
import getKhattabatStore from "..";
import getCorePopUpStore from "../../core/core-popup-store";
import { apiCallSendOneOTwoMessage } from "../../../api/khattbat-api/api-call-send-one-o-two-message";
import { khattabaConversationParsing } from "../../../helpers/et3-conversation-parse";
import getKhattabatSharedMessagingStore from "./conversation-messaging-store";

class Khattabat102MessagingStore {
  conversationID = observable.box<string>("");
  senderID = observable.box<number>(0);
  senderUUID = observable.box<string>("");
  senderName = observable.box<string>("");
  clientReceiverID = observable.box<number>(0);
  clientReceiverUUID = observable.box<string>("");
  clientReceiverName = observable.box<string>("");
  matchReceiverID = observable.box<number>(0);
  matchReceiverUUID = observable.box<string>("");
  matchReceiverName = observable.box<string>("");
  isSilentBanned = observable.box<number>(0);

  sendMessage = async () => {
    const conversationID = this.conversationID.get();
    const { messageField, isSending, appendMessage, setMessageField } =
      getKhattabatSharedMessagingStore(conversationID);
    const messageText = khattabaConversationParsing(messageField.get());
    const alkhattabaUUID = getKhattabatStore().alkhattabaUUID.get();

    if (
      isSending.get() ||
      !isDefinedString(alkhattabaUUID) ||
      !isDefinedString(messageText)
    ) {
      return;
    }
    runInAction(() => {
      isSending.set(true);
    });
    const { status, code, data } = await apiCallSendOneOTwoMessage({
      oneOTwoConversationId: conversationID
    });
    runInAction(() => {
      isSending.set(false);
    });
    if (status === "OK") {
      const databaseCurrentTime = reduce(() => data.currentTime, DEFAULT_TIME);
      appendMessage({
        isKhattabaMessage: 1,
        isClientMessage: 0,
        message: messageText,
        messageType: "text",
        createdOn: databaseCurrentTime,
        isSeen: 0,
        senderGender: "f",
        conversationId: conversationID
      });
      setMessageField("");
    } else {
      getCorePopUpStore().showAlertMessage(code);
    }
  };
}

const getKhattabat102MessagingStore = memoize((conversationID: string) => {
  const store = new Khattabat102MessagingStore();
  store.conversationID.set(conversationID);
  return store;
});
export default getKhattabat102MessagingStore;
